var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"canvas"},[_c('canvas',{staticStyle:{"width":"124px","height":"124px"},attrs:{"id":_vm.id,"width":"160","height":"160"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }